import { Axis as d3Axis, axisBottom, NumberValue, ScaleLinear, select, ticks, tickStep } from 'd3'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import { formatAmount } from 'utils/formatDollarAmt'

const StyledGroup = styled.g`
  line {
    display: none;
  }
  text {
    color: ${({ theme }) => theme.deprecated_text2};
    transform: translateY(5px);
  }
`

const Axis = ({ axisGenerator }: { axisGenerator: d3Axis<NumberValue> }) => {
  const axisRef = (g: SVGGElement) => {
    g &&
      select(g)
        .call(axisGenerator)
        .call((s) => s.select('.domain').remove())
  }
  return <g ref={axisRef} />
}

export const AxisBottom = ({
  xScale,
  innerHeight,
  offset = 0,
}: {
  xScale: ScaleLinear<number, number>
  innerHeight: number
  offset?: number
}) => {
  const TICKS = 6

  const axisGen = useMemo(() => {
    const [a, b] = xScale.domain()
    const d0 = Math.min(a, b)
    const d1 = Math.max(a, b)

    const lo = Math.max(0, d0)
    const hi = d1

    if (!(hi > lo)) {
      return axisBottom(xScale)
        .tickValues([0])
        .tickFormat(() => '0')
    }

    let vals = ticks(lo, hi, TICKS)

    const step = tickStep(lo, hi, TICKS) || (hi - lo) / TICKS
    const EPS = Math.abs(step) * 1e-3
    if (d0 < 0 && d1 > 0 && !vals.some((t) => Math.abs(t) < EPS)) vals = [0, ...vals]

    vals = Array.from(new Set(vals.map((t) => (Math.abs(t) < EPS ? 0 : t))))

    const formatTick = (v: number) => {
      if (Math.abs(v) < EPS) return '0'
      const sign = v < 0 ? '-' : ''
      const abs = Math.abs(v)

      if (abs < 1) return sign + abs

      const s = formatAmount(abs, 2).replace('K', 'k')
      return sign + s
    }

    return axisBottom(xScale)
      .tickValues(vals)
      .tickFormat((v: any) => formatTick(v as number))
  }, [xScale])

  return (
    <StyledGroup transform={`translate(0, ${innerHeight + offset})`}>
      <Axis axisGenerator={axisGen} />
    </StyledGroup>
  )
}
